export { default } from "/home/flare/repos/jsonhero-web/app/routes/index.tsx";